import {Model, View} from "@lernetz/ts-lib";
import {gateway} from "../../services/gateway";
import {paramService} from "../../services/params.service";
import {tagService} from "../../services/tag.service";
import template from "./results.component.html";

export class ResultPage extends View {
    constructor() {
        super({ template });
    }
}

export class ResultPageController extends Model {
    tags: string[];
    tools: any;
    constructor(private currentLang: string) {
        super();
    }
    init() {
        gateway.loadFilters().then(filterCategories => {
            const tagSlugs = paramService.parseParams();
            this.tags = tagService.getActiveTagsFromParam(filterCategories, tagSlugs);
            this.loadItems();
        })
    }

    loadItems() {
        gateway.toolGateway
            .loadFilteredTools(paramService.createParams(this.tags))
            .then((tools) => (this.tools = tools));
    }
}
